/**
 * 虚拟中心
 */
import fetch from "./fetch";

const vrManage = {
  /** 任务池列表分页 */
  getWhTaskPage(data) {
    return fetch({
      isLoading: true,
      url: "/wh-task/page",
      method: "GET",
      params: data,
    });
  },
  /** 删除任务 */
  deleteWhTask(data) {
    return fetch({
      isLoading: true,
      url: "/wh-task/delete",
      method: "POST",
      data,
    });
  },

  /** 下载任务导入模板 */
  downloadTem() {
    return fetch({
      isLoading: true,
      url: "/wh-task/downloadTem",
      method: "GET",
      responseType: "blob",
    });
  },

  /** 新增任务池数据 */
  whTaskSave(data) {
    return fetch({
      isLoading: true,
      url: "/wh-task/save",
      method: "POST",
      data,
    });
  },

  /** 获取虚拟客服代表 */
  getVirtualDeputy(data) {
    return fetch({
      isLoading: true,
      url: "/wh-task/virtualDeputy",
      method: "GET",
      params: data,
    });
  },

  /** 获取任务相关的虚拟代表详情 */
  getVirtual(data) {
    return fetch({
      isLoading: true,
      url: "/wh-task/getVirtual",
      method: "GET",
      params: data,
    });
  },

  /** 任务分配保存 */
  saveAssignment(data) {
    return fetch({
      isLoading: true,
      url: "/wh-task/saveAssignment",
      method: "POST",
      data,
    });
  },

  /** 查询话术配置详情 */
  getScriptDetail(data) {
    return fetch({
      isLoading: true,
      url: "/wh-question-config/selectDraft",
      method: "GET",
      params: data,
    });
  },

  /** 保存话术触达 */
  saveScriptTouch(data) {
    return fetch({
      isLoading: true,
      url: "/wh-question-config/draft",
      method: "POST",
      data,
    });
  },
  /** 保存话术调研 */
  saveScriptResearch(data) {
    return fetch({
      isLoading: true,
      url: "/wh-question-config/createQuestion",
      method: "POST",
      data,
    });
  },

  /** 外呼任务列表 */
  getDoctorInfoPage(data) {
    return fetch({
      isLoading: true,
      url: "/wh-doctor-info/page",
      method: "GET",
      params: data,
    });
  },

  /** 医生信息列表查看 */
  getDoctorInfoSelect(data) {
    return fetch({
      isLoading: true,
      url: "/wh-doctor-info/select",
      method: "GET",
      params: data,
    });
  },

  /** 呼叫医生信息详情 */
  getDoctorInfoDoctorDetail(data) {
    return fetch({
      isLoading: true,
      url: "/wh-doctor-info/doctor/info",
      method: "GET",
      params: data,
    });
  },

  /** 医生通话标记 */
  whDoctorInfoDoctorTag(data) {
    return fetch({
      isLoading: true,
      url: "/wh-doctor-info/doctor/tag",
      method: "POST",
      data,
    });
  },

  /** 医生信息编辑 */
  whDoctorInfoUpdate(data) {
    return fetch({
      isLoading: true,
      url: "/wh-doctor-info/update",
      method: "POST",
      data,
    });
  },

  /** 历史通话记录查看 */
  whDoctorInfoCallRecords(data) {
    return fetch({
      isLoading: true,
      url: "/wh-doctor-info/select/CallRecords",
      method: "POST",
      data,
    });
  },

  /** 呼叫-话术-触达详情 */
  whDoctorInfoCallReach(data) {
    return fetch({
      isLoading: true,
      url: "/wh-doctor-info/call/reach",
      method: "GET",
      params: data,
    });
  },

  /** 呼叫-话术-调研详情 */
  whDoctorInfoCallResearch(data) {
    return fetch({
      isLoading: true,
      url: "/wh-doctor-info/call/research",
      method: "GET",
      params: data,
    });
  },

  /** 信息补充新增或修改 */
  whAnswerUpdate(data) {
    return fetch({
      isLoading: true,
      url: "/wh-answer/update",
      method: "POST",
      data,
    });
  },
};

export default vrManage;
